import { ActionTypes } from '../actions/types';
import { StateModel_Auftragsvorlageerfassung } from '../store';

const initialState: StateModel_Auftragsvorlageerfassung = {
  id: undefined,
  vorlageName: '',
  mandant: undefined,
  exists: [],
  auftrag: undefined,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.RESET_AUFTRAGSVORLAGEERFASSUNG:
      return {
        ...initialState,
      };
    case ActionTypes.SET_AUFTRAGSVORLAGEERFASSUNG_FIELD: {
      const [value, fieldName] = [payload.value, payload.fieldName];
      return {
        ...state,
        [fieldName]: value,
      };
    }
    case ActionTypes.VORLAGE_NAME_EXISTS: {
      return {
        ...state,
        exists: payload,
      };
    }
    default:
      return state;
  }
}
